import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('ImportProducts', [
    'TABLE_RESULT',
    'REPORT_STATE',
    'BUTTONS',
    'BUTTON_BACK',
    'IMPORT'
])
